import { Input, Select } from "antd";
import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import { useAdmin } from "../../context/adminContext";
import { useEffect, useState } from "react";

const SearchAdmin = ({
  title,
  fieldName,
  select,
  width = 200,
  noSearch = false,
  sort = true,
  debounceMs = 0,
  placeholder = "Хайх...",
}) => {
  const { searchFields, setSearchFields, showFilter } = useAdmin();
  const [localValue, setLocalValue] = useState(searchFields[fieldName] || "");

  useEffect(() => {
    setSearchFields((e) => {
      return { ...e, [fieldName]: null };
    });
  }, []);

  useEffect(() => {
    setLocalValue(searchFields[fieldName] || "");
  }, [searchFields[fieldName]]);

  useEffect(() => {
    if (!debounceMs) return undefined;

    const timer = setTimeout(() => {
      setSearchFields((prev) => ({
        ...prev,
        [fieldName]: localValue || null,
      }));
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [localValue, debounceMs, fieldName, setSearchFields]);

  const valueChange = (e) => {
    const currValue = e.target.value;
    if (debounceMs) {
      setLocalValue(currValue);
      return;
    }
    setSearchFields((prev) => ({
      ...prev,
      [fieldName]: currValue || null,
    }));
  };

  const selectChange = (value) => {
    setSearchFields((prev) => ({
      ...prev,
      [fieldName]: value || null,
    }));
  };

  const sortChange = (sort) => {
    setSearchFields({ ...searchFields, sort: sort, sortField: fieldName });
  };

  const inputValue = debounceMs ? localValue : searchFields[fieldName];

  return (
    <div
      key={fieldName}
      className="table-search-field"
      style={{ minWidth: width, width: "100%" }}
    >
      <div className="titleWithSort">
        <span className="table-search-field__title">{title}</span>
        {sort && (
          <div className="sortIcons">
            <CaretUpOutlined
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("asc")}
            />
            <CaretDownFilled
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("desc")}
            />
          </div>
        )}
      </div>
      {showFilter && (
        <>
          <div className="line" />
          {noSearch ? (
            <div style={{ height: 32 }} />
          ) : (
            <div className="table-search-field__input-wrap">
              {select ? (
                <Select
                  size="middle"
                  allowClear
                  value={(searchFields && searchFields[fieldName]) || null}
                  style={{ width: "100%", minWidth: width }}
                  onChange={selectChange}
                >
                  {select.map((e, i) => {
                    return (
                      <Select.Option key={i} value={e.value}>
                        {e.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              ) : (
                <Input
                  size="middle"
                  allowClear
                  style={{ width: "100%", minWidth: width }}
                  placeholder={placeholder}
                  value={inputValue}
                  onChange={valueChange}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default SearchAdmin;
